class ShareButton extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('[data-share-trigger]');
      if (!this.trigger) return;
      this.trigger.addEventListener('click', () => this.share());
    }
  
    async share() {
      const data = {
        title: this.dataset.shareTitle,
        text: this.dataset.shareText,
        url: this.dataset.shareUrl,
      };
  
      if (navigator.share && (!navigator.canShare || navigator.canShare(data))) {
        try {
          await navigator.share(data);
        } catch (err) {
          if (err.name !== 'AbortError') this.fallback();
        }
      } else {
        this.fallback();
      }
    }
  
    async fallback() {
      // e.g. copy URL to clipboard and show a confirmation
      try {
        await navigator.clipboard.writeText(this.dataset.shareUrl);
        // toast / label swap
      } catch (_) {}
    }
  }
  customElements.define('share-button', ShareButton);